import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';

const TruncateByLines = styled(Box)`
    display: -webkit-box;
    -webkit-line-clamp: ${({ limit }) => limit};
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
const Styled = {
  TruncateByLines
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
